import ConfirmationService from 'primevue/confirmationservice';
import Pinia from './pinia';
import PrimeVue from 'primevue/config';
import i18n from './i18n';
import router from './router';
import { axios } from './axios';
import { resetAllStores } from './pinia';

export default [i18n, Pinia, PrimeVue, router, ConfirmationService];
export { axios, resetAllStores };
